import { convertWeight } from '../weights/weight-convert-service';
import { convertDimensions } from '../dimensions/dimension-convert-service';

export const convertPackageWeightAndDimensions = (parcel, weightUnit, dimensionsUnit) => {
  const validPackage = parcel || {};
  return {
    ...validPackage,
    weight: convertWeight(validPackage.weight, weightUnit),
    dimensions: convertDimensions(validPackage.dimensions, dimensionsUnit),
  };
};
